import React from 'react'
import cx from 'classnames'

const PageTitle = (props) => {
	let {
		enablePageTitleSubheading,
		heading,
		subheading
	} = props

	return (
		<div className="app-page-title">
			<div className="page-title-wrapper">
				<div className="page-title-heading">
					<div style={{paddingTop: '75px'}}>
						{heading}
						<div className={cx('page-title-subheading', { 'd-none': !enablePageTitleSubheading })}>
							{subheading}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default PageTitle
